import { render, staticRenderFns } from "./ImportFiscalManageView.vue?vue&type=template&id=50980cdf&scoped=true&"
import script from "./ImportFiscalManageView.vue?vue&type=script&lang=js&"
export * from "./ImportFiscalManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50980cdf",
  null
  
)

export default component.exports